import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E13",
    audio: "",
    video: "",
    component: Circle_Write,
    exerciseKey: "img/FriendsPlus/Page34/E1/Key/E1answerKey.png",
    titleQuestion: [
      {
        num: "1",
        title: `
				Choose the correct word.
				`,
        color: "rgb(244,130,39)",
        star: 1,
      },
    ],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: "-40px",
          fontWeight: 600,
          fontStyle: "italic",
          color: "",
          // fontSize: 27,
          borderRadius: "50%",
          // marginInline: '-1px',
        },
        selectWordStyle: { border: "2px solid rgb(0, 173, 238)" },
        limitSelect: 1,
        listWordsStyle: {},
        listWords: [
          `up / out`,
          `pass / spend`,
          `win / earn`,
          `down / up`,
          `settled / taken`,
          `look / tie`,
        ],
        answers: ["0-4", "1-4", "2-4", "3-4", "4-0", "5-4"],
        initialValue: [],
      },
      Layout: `
      <div>

      They’re getting married and plan to <strong> get / <span  style="border-radius: 20px; border: 3px solid rgb(72,99,192);padding:2px">have</span></strong> a 
      family.<br>

      <div style="margin-top: 5px; display: flex; gap: 20px;">
        <div style="font-weight: bold; text-align: right;">1</div>
        <div>
        They decided to take some time <input id='0' type='Circle' />.  some time abroad in 
        travel before university
        </div>
      </div>
      <div style="margin-top: 5px; display: flex; gap: 20px;">
        <div style="font-weight: bold; text-align: right;">2</div>
        <div>
        We always <input id='1' type='Circle' /> some time abroad in 
        the holidays.
         
        </div>
      </div>
      <div style="margin-top: 5px; display: flex; gap: 20px;">
        <div style="font-weight: bold; text-align: right;">3</div>
        <div>
        It’s a nice job, but I don’t <input id='2' type='Circle' />  much money
         
        </div>
      </div>
      <div style="margin-top: 5px; display: flex; gap: 20px;">
      <div style="font-weight: bold; text-align: right;">4</div>
      <div>
      I’d like to take <input id='3' type='Circle' /> a new sport. Which 
one do you recommend?
       
      </div>
    </div>
    <div style="margin-top: 5px; display: flex; gap: 20px;">
    <div style="font-weight: bold; text-align: right;">5</div>
    <div>
    My uncle has never <input id='4' type='Circle' /> down and 
    got married.
     
    </div>
  </div>
  <div style="margin-top: 5px; display: flex; gap: 20px;">
  <div style="font-weight: bold; text-align: right;">6</div>
  <div>
  Elena doesn’t want to <input id='5' type='Circle' /> down 
yet with a family and a house.
   
  </div>
</div>
    </div>
			  `,
    },
  },
  // 2: {
  // 	unit: 'Unit 3',
  // 	id: 'FP8-SB-demo-2023-U3-P34-E2',
  // 	exerciseKey: 'img/FriendsPlus/Page34/E1/key/answerkey.png',
  // 	component: Circle_Write,
  // 	titleQuestion: [
  // 		{
  // 			num: '2',
  // 			title: `
  // 				Read <i>Your Top Five Extreme Adventures</i> and
  // 				check the meaning of the sports verbs in
  // 				<span style='color: rgb(0, 173, 238);'>blue</span>. Then choose the correct prepositions.
  // 			`,
  // 			color: 'rgb(245, 128, 37)',
  // 		},
  // 	],
  // 	question: {
  // 		Write: {
  // 			inputStyle: {},
  // 			answers: [],
  // 			initialValue: [],
  // 		},
  // 		Circle: {
  // 			initialWordStyle: {
  // 				padding: '-40px',
  // 				fontWeight: 500,
  // 				fontSize: 22,
  // 				fontStyle: 'italic',
  // 				color: '',
  // 				borderRadius: '50%',
  // 			},
  // 			selectWordStyle: { border: '2px solid rgb(0, 173, 238)' },
  // 			limitSelect: 1,
  // 			listWordsStyle: {},
  // 			listWords: [
  // 				`around / on`,
  // 				`through / up`,
  // 				`over / off`,
  // 				`- / off`,
  // 				`down / under`,
  // 			],
  // 			answers: ['0-4', '1-0', '2-0'],
  // 			initialValue: [],
  // 		},
  // 		Layout: `
  // 			<div style='position: relative;'>
  // 				<div><img src='img/FriendsPlus/Page34/E2/1.jpg' width='100%' /></div>
  // 				<div style='position: absolute; top: 117px; left: 880px;'><input id='0' type='Circle' /></div>
  // 				<div style='position: absolute; top: 269px; left: 673px;'><input id='1' type='Circle' /></div>
  // 				<div style='position: absolute; top: 360px; left: 655px;'><input id='2' type='Circle' /></div>
  // 				<div style='position: absolute; top: 422px; left: 655px;'><input id='3' type='Circle' /></div>
  // 				<div style='position: absolute; top: 485px; left: 668px;'><input id='4' type='Circle' /></div>
  // 			</div>
  // 			`,
  // 	},
  // },
  2: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P33-E2",
    audio: "",
    exerciseKey: "img/FriendsPlus/Page34/E2/key/E2answerkey.png",
    component: T6v2,
    inputSize: 120,
    stylesTextInput: {
      fontSize: "24px",
      background: "transparent",
      border: "none",
    },
    titleQuestion: [
      {
        num: "2",
        title: `
        Complete Jen’s essay with the correct 
        form of the verbs.
				`,
        color: "rgb(244,130,39)",
        star: 2,
      },
    ],
    textareaStyle: {
      width: 700,
    },
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style="display:flex;flex-direction:column">
        <img src="img/FriendsPlus/Page34/E2/1.png" />

        <div style="display:inline-block;position:relative">
        <img src="img/FriendsPlus/Page34/E2/2.png" style="width:700px"/>
        		
    <span style="position:absolute;top:475px;left:120px">#</span>
    <span style="position:absolute;top:538px;left:120px">#</span>
    <span style="position:absolute;top:535px;left:480px">#</span>
    <span style="position:absolute;top:642px;left:120px">#</span>
    <span style="position:absolute;top:705px;left:260px">#</span>
    <span style="position:absolute;top:735px;left:380px">#</span>
    <span style="position:absolute;top:795px;left:320px">#</span>
    <span style="position:absolute;top:828px;left:307px">#</span>
        </div>
  
        </div>

   
    
      `,
        answer: [
          `enjoying`,
          `’ll travel`,
          `get`,
          `look`,
          `waste`,
          `start`,
          `make`,
          `retire`,
        ],
      },
    ],
  },
  3: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P34-E5",
    component: T6v2,
    audio: "Audios/1-11 Friends Plus 8_WB.mp3",
    exerciseKey: "img/FriendsPlus/Page34/E3/Key/E3answerKey.png",
    // hideBtnFooter: true,
    textareaStyle: { width: 730 },
    inputSize: 120,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      fontSize: "24px",
      borderBottom: "1px  dotted rgb(204, 204, 204)",
    },
    titleQuestion: [
      {
        num: "3",
        title: `
        <headphone name="11"></headphone>
             Listen to Bruno, a TV presenter, 
        talking about a time capsule. Write true or false.
				`,
        color: "rgb(244,130,39)",
        star: 2,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
				Bruno works on a TV programme for older people. <br>
        <strong style="text-decoration:underline">false</strong>
      <div style="display:flex;flex-direction:column">
      <span><strong style="margin-right:30px">1</strong>They want people to say what should go into 
      the time capsule. #</span>
      <span><strong style="margin-right:30px">2</strong>They’re going to open the time capsule in 200 
      years. #</span>
      <span><strong style="margin-right:30px">3</strong>They have already put some things into the 
      time capsule. #</span>
      <span><strong style="margin-right:30px">4</strong>Bruno makes predictions about life in the 
      future. #</span>
      <span><strong style="margin-right:30px">5</strong>Bruno is advertising a competition. #</span></div>
        `,
        answer: [`true`, `false`, `true`, `false`, `true`],
      },
    ],
  },
  6: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P34-E6",
    component: T6v2,
    hideBtnFooter: true,
    inputSize: 250,
    stylesTextInput: {
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "6",
        title: `<headphone name="12"></headphone>
					Work with a partner. Ask and 
					answer questions about adventure activities. 
					Use the ideas below.
				`,
        color: "rgb(245, 128, 37)",
        prefix: { icons: ["far fa-comment"], text: "USE IT!" },
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
	
					<div style='display: flex; gap: 40px;'>
						<div>
							<div>Do you like the look of … ?</div>
							<div>Would you like to try … ?</div>
						</div>
						<div>
							<div>Have you ever tried … ?</div>
							<div>What do you think of … ?</div>
						</div>
					</div>
				`,
        answer: [],
      },
    ],
  },
  4: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P34-E4",
    audio: "Audios/1-12 Friends Plus 8_WB.mp3",
    exerciseKey: "img/FriendsPlus/Page34/E4/key/E4answerkey.png",
    component: T6v2,
    inputSize: 120,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      fontSize: "24px",
      borderBottom: "1px  dotted rgb(204, 204, 204)",
    },
    titleQuestion: [
      {
        num: "4",
        title: ` <headphone name="12"></headphone>
        Now listen to three responses 
        from David, Lena and Claire. Write the speaker’s 
        name next to the ideas.
				`,
        color: "rgb(244,130,39)",
        star: 2,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <strong style="text-decoration:underline">Lena</strong> loves reading
					<div style='display: flex; gap: 20px; flex-direction: column;'>
          <span><strong style="margin-right:30px">1</strong>#  is excited about the future.</span>
        
          <span><strong style="margin-right:30px">2</strong>#  has got a busy life now.</span>
					
          <span><strong style="margin-right:30px">3</strong>#  thinks we’ll work less.</span>
					
          <span><strong style="margin-right:30px">4</strong>#  thinks we’ll see friends less.</span>
					
          <span><strong style="margin-right:30px">5</strong>#  wants to keep his / her laptop.</span>
					
          <span><strong style="margin-right:30px">6</strong>#  thinks exercise is important.</span>
					
					</div>
        `,
        answer: [`Lena`, `Claire`, `Lena`, `David`, `David`, `Claire`],
      },
    ],
  },
  5: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P34-E4",
    audio: "",
    exerciseKey: "img/FriendsPlus/Page34/E4/key/answerkey.png",
    component: T6v2,
    inputSize: 320,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      fontSize: "24px",
      borderBottom: "1px  dotted rgb(204, 204, 204)",
    },
    titleQuestion: [
      {
        num: "5",
        title: `
        Write your own ideas about life in 
        100 years’ time. Think about:
				`,
        color: "rgb(244,130,39)",
        star: 3,
      },
    ],
    textareaStyle: {
      width: 900,
    },
    isHiddenCheck: true,
    questions: [
      {
        title: `
          <div style="display:flex;flex-direction:column">

          <div style="display:flex;flex-direction:row">
          
          <ul style="margin-right:300px">
           <li>travel</li>
           <li>work</li>
           <li>education</li>
          </ul>

          <ul>
          <li> entertainment</li>
          <li>the environment</li>
          <li>health and medicine</li>
         </ul>


          
          </div>


          <strong style="text-decoration:underline">I think we’ll live longer and retire later. We might all
          travel in electric cars and ...</strong>

          <textarea id="0" rows=8></textarea>
          
          
          
          </div>
        `,
        answer: [
          `He cycled over a volcano.`,
          `She was sixteen.`,
          `No`,
          `The boy was from the USA, and the girl was from India.`,
          `The surfer, Garrett McNamara, has the most votes.`,
        ],
      },
    ],
  },
  6: {
    unit: "Unit 3",
    id: "FP8-SB-demo-2023-U3-P34-E4",
    audio: "Audios/1-12 Friends Plus 8_WB.mp3",
    exerciseKey: "img/FriendsPlus/Page34/E4/key/answerkey.png",
    component: T6v2,
    inputSize: 320,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      fontSize: "24px",
      borderBottom: "1px  dotted rgb(204, 204, 204)",
    },
    titleQuestion: [
      {
        num: "6",
        title: `
        Listen to David, Lena and Claire 
again. Are you more positive or negative about 
the future? Explain why.
				`,
        color: "rgb(244,130,39)",
        star: 3,
      },
    ],
    textareaStyle: {
      width: 900,
    },
    isHiddenCheck: true,
    questions: [
      {
        title: `
          <div style="display:flex;flex-direction:column">

        


          
       


          <strong style="text-decoration:underline">I’m more positive than David because I think we’ll still <br>
          travel to see friends, but I’m more negative ... </strong>

          <textarea id="0" rows=8></textarea>
          
          
          
          </div>
        `,
        answer: [
          `He cycled over a volcano.`,
          `She was sixteen.`,
          `No`,
          `The boy was from the USA, and the girl was from India.`,
          `The surfer, Garrett McNamara, has the most votes.`,
        ],
      },
    ],
  },
};

export default json;
